"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var template = require("./Reminder.html"),
    RegionalLayout = require("./../../layouts/RegionalLayout.js"),
    UIComponent = require("./../UIComponent.js"),
    Popup = require("./../PopupModal/PopupModal.js"),
    ComponentModal = require("./../PopupModal/ComponentModal.js");
var Reminder = function (_UIComponent) {
  _inherits(Reminder, _UIComponent);

  function Reminder(e) {
    var _this;

    _classCallCheck(this, Reminder);

    (_this = _possibleConstructorReturn(this, (Reminder.__proto__ || Object.getPrototypeOf(Reminder)).call(this, template, { layout: RegionalLayout, title: "Reminder" })), _this), _this.reminder = { ReminderDate: moment().toDate(), ReminderTime: moment().hour(), ReminderMinute: moment().minute(), EventDate: moment().millisecond(), Meridiem: "PM", FirstName: "", MiddleName: "", LastName: "", Email: "", SMSNumber: "", ReminderType: 1, EventId: 0, TextingEnabled: e.textingEnabled };return _this;
  }

  _createClass(Reminder, [{
    key: "onComponentReadyAsync",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.createReminder(), this.refs.email.addEventListener("blur", this.setEmail.bind(this)), this.refs.cellPhone.addEventListener("blur", this.setText.bind(this)), this.refs.emailCheckbox.addEventListener("change", this.hideShowEmail.bind(this)), this.refs.textMsgCheckbox.addEventListener("change", this.hideShowTextMsg.bind(this));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onComponentReadyAsync() {
        return _ref.apply(this, arguments);
      }

      return onComponentReadyAsync;
    }()
  }, {
    key: "createReminder",
    value: function createReminder() {
      $(this.refs.dateSelector).daterangepicker({ singleDatePicker: !0, defaultDate: this.reminder.ReminderDate }), this.refs.dateSelector.value = this.reminder.ReminderDate, this.refs.hour.value = this.reminder.ReminderTime, this.refs.minute.value = this.reminder.ReminderMinute, this.refs.meridiem.value = this.reminder.Meridiem, this.refs.email.value = this.reminder.Email, this.refs.cellPhone.value = this.reminder.SMSNumber, $(this.refs.divCellPhone).toggle(), this.reminder.TextingEnabled && $(this.refs.checkbox).removeAttr("hidden");
    }
  }, {
    key: "hideShowEmail",
    value: function hideShowEmail() {
      $(this.refs.divEmail).toggle(), this.changeReminderType();
    }
  }, {
    key: "hideShowTextMsg",
    value: function hideShowTextMsg() {
      $(this.refs.divCellPhone).toggle(), this.changeReminderType();
    }
  }, {
    key: "changeReminderType",
    value: function changeReminderType() {
      1 == this.refs.emailCheckbox.checked && 1 == this.refs.textMsgCheckbox.checked ? this.reminder.ReminderType = 3 : 1 == this.refs.emailCheckbox.checked && 0 == this.refs.textMsgCheckbox.checked ? this.reminder.ReminderType = 1 : 0 == this.refs.emailCheckbox.checked && 1 == this.refs.textMsgCheckbox.checked && (this.reminder.ReminderType = 2);
    }
  }, {
    key: "validate",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", 0 != this.refs.emailCheckbox.checked || 0 != this.refs.textMsgCheckbox.checked || ($(this.refs.errorCheckbox).removeAttr("hidden"), !1));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validate() {
        return _ref2.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "setEmail",
    value: function setEmail() {
      this.reminder.Email = this.refs.email.value;
    }
  }, {
    key: "setText",
    value: function setText() {
      this.reminder.SMSNumber = this.refs.cellPhone.value;
    }
  }, {
    key: "onDetach",
    value: function onDetach() {}
  }, {
    key: "LeadFirstName",
    get: function get() {
      return this.reminder.FirstName;
    },
    set: function set(e) {
      this.reminder.FirstName = e;
    }
  }, {
    key: "LeadMiddleName",
    get: function get() {
      return this.reminder.MiddleName;
    },
    set: function set(e) {
      this.reminder.MiddleName = e;
    }
  }, {
    key: "LeadLastName",
    get: function get() {
      return this.reminder.LastName;
    },
    set: function set(e) {
      this.reminder.LastName = e;
    }
  }, {
    key: "LeadEmail",
    get: function get() {
      return this.reminder.Email;
    },
    set: function set(e) {
      this.reminder.Email = e;
    }
  }, {
    key: "LeadSMSNumber",
    get: function get() {
      return this.reminder.SMSNumber;
    },
    set: function set(e) {
      this.reminder.SMSNumber = e;
    }
  }, {
    key: "ReminderDate",
    get: function get() {
      return this.reminder.ReminderDate;
    },
    set: function set(e) {
      this.reminder.ReminderDate = e;
    }
  }, {
    key: "ReminderTime",
    get: function get() {
      return this.reminder.ReminderTime;
    },
    set: function set(e) {
      this.reminder.ReminderTime = e;
    }
  }, {
    key: "ReminderMinute",
    get: function get() {
      return this.reminder.ReminderMinute;
    },
    set: function set(e) {
      this.reminder.ReminderMinute = e;
    }
  }, {
    key: "ReminderMeridiem",
    get: function get() {
      return this.reminder.Meridiem;
    },
    set: function set(e) {
      this.reminder.Meridiem = e;
    }
  }, {
    key: "EventDate",
    get: function get() {
      return this.reminder.EventDate;
    },
    set: function set(e) {
      this.reminder.EventDate = e;
    }
  }]);

  return Reminder;
}(UIComponent);

module.exports = Reminder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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